import { useEffect } from "react";
import { getDeviceFingerprint } from "@/lib/fingerprint";
import { useAppStore } from "@/store";

function FingerprintInit() {
  useEffect(() => {
    getDeviceFingerprint().catch(() => {});
  }, []);
  return null;
}

function SubscriptionSync() {
  const { authToken, fetchSubscription, logoutUser, refreshAuthToken } = useAppStore();
  useEffect(() => {
    if (!authToken) return;

    const baseUrl = import.meta.env.BASE_URL.replace(/\/$/, "");
    fetch(`${baseUrl}/api/auth/me`, {
      headers: { Authorization: `Bearer ${authToken}` },
    })
      .then(async (res) => {
        if (res.status === 401) {
          try {
            const body = await res.json();
            const msg: string = body?.error ?? "";
            if (msg.toLowerCase().includes("invalid")) {
              logoutUser();
            }
          } catch {
          }
        } else if (res.ok) {
          try {
            const body = await res.json();
            if (body?.token && typeof body.token === "string") {
              refreshAuthToken(body.token);
            }
          } catch {
          }
          fetchSubscription();
        }
      })
      .catch(() => {});
  }, [authToken, fetchSubscription, logoutUser, refreshAuthToken]);
  return null;
}

export function AppBootstrap() {
  return (
    <>
      <FingerprintInit />
      <SubscriptionSync />
    </>
  );
}
